import script from "./IndexView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndexView.vue?vue&type=script&setup=true&lang=ts"

import "./IndexView.vue?vue&type=style&index=0&id=018420ae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-018420ae"]])

export default __exports__